import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a6ceaae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-item-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "grid-item-head-title" }, "地図表示")
], -1))
const _hoisted_2 = { class: "grid-item-body" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = { class: "controls" }

import { computed, ref } from 'vue'
import { useGlobalStore } from '@/stores/globalStore'
import { DefinitionInfoSummaryItemMap } from '@/models/initData/DefinitionInfo'
import MapOL from '@/components/top/MapOL.vue'
import RainCloudController from '@/components/top/RainCloudController.vue'
import { useInitDataStore } from '@/stores/initDataStore'

type MapPanelProps = {
  cell: DefinitionInfoSummaryItemMap
}


export default /*#__PURE__*/_defineComponent({
  props: {
    cell: null
  },
  setup(__props: any) {

const props = __props as {
  cell: DefinitionInfoSummaryItemMap
}



const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const renderLayer = ref('radar_rain')

const rainModeClass = computed(() => {
  return renderLayer.value === 'radar_rain' ? 'active' : ''
})

const stations = computed(() => {
  const targets = props.cell.args.stationList.map(station => {
    const target = initDataStore.initData.stationList.find(s => s.stationId === station.stationId)

    return { ...target, ...station }
  })

  return targets.filter(t => t)
})

const setRainMode = () => {
  renderLayer.value = renderLayer.value === 'radar_rain' ? '' : 'radar_rain'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: setRainMode,
          class: _normalizeClass([_unref(rainModeClass), "icon"])
        }, null, 2)
      ]),
      (!_unref(globalStore).topIsGraphical)
        ? (_openBlock(), _createBlock(MapOL, {
            key: 0,
            mapType: "summary",
            field: "move_rain_min_10",
            stations: _unref(stations)
          }, null, 8, ["stations"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_unref(globalStore).topIsSummery && renderLayer.value == 'radar_rain')
          ? (_openBlock(), _createBlock(RainCloudController, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})